// extracted by css-extract-rspack-plugin
export default {"Wrapper":"jmUrH","Main":"S2xzh","AdminPeopleApp":"g6kz7","Sidebar":"LDfF2","Content":"TZ0B7"};